import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type FileStatusPanelSummaryProps = ComponentPropsWithoutRef<'div'>;

export const FileStatusPanelSummary = memo(({ className, ...restOfProps }: FileStatusPanelSummaryProps) => (
  <div className={cn('px-4 pb-3', className)} {...restOfProps} />
));

FileStatusPanelSummary.displayName = 'FileStatusPanelSummary';
